import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";

export class ReturnFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return [
            FootballState.Returned,
            FootballState.NoRecoveryKickReturn
        ].some((state) => state === fragment.associatedState);
    }

    getRawFragment(play, serializationContext, returned) {
        let rawPlay = "";

        const formattedFieldPosition = this.resolveFormattedFieldPosition(
            serializationContext,
            returned.getFieldPosition()
        );

        const values = [
            this.resolveUniform(serializationContext, returned.getPlayers()[0]),
            formattedFieldPosition
        ];

        rawPlay = `RET:${values.join()}`;

        return rawPlay;
    }
}
